// i18next-extract-mark-ns-start Footer

import { pushOrderStartToGTM } from '../../CTALink';
import { TFunction } from '../../../types/t-types';
import routesMap from '../../../Routes';

export const getLeatherGoodLink = (city: string) => ({ text: `Maroquinerie ${city}`, url: `/maroquinerie/${city.toLowerCase()}/` });
export const getAlterationLink = (city: string) => ({ text: `Retouche ${city}`, url: `/retouche-vetement/${city.toLowerCase()}/` });

export const getLocalisationBlock = (isLeatherGoods: boolean) => {
  if (isLeatherGoods) {
    return [
      getLeatherGoodLink('Paris'),
      getLeatherGoodLink('Lyon'),
      getLeatherGoodLink('Marseille'),
      getLeatherGoodLink('Bordeaux'),
      getLeatherGoodLink('Toulouse'),
      getLeatherGoodLink('Lille'),
      getLeatherGoodLink('Nantes'),
      getLeatherGoodLink('Nantes'),
      getLeatherGoodLink('Nice'),
      getLeatherGoodLink('Rennes'),
    ];
  }
  return [
    getAlterationLink('Paris'),
    getAlterationLink('Lyon'),
    getAlterationLink('Marseille'),
    getAlterationLink('Bordeaux'),
    getAlterationLink('Toulouse'),
    getLeatherGoodLink('Paris'),
    getLeatherGoodLink('Lyon'),
  ];
};

export const getFooterContent = (t: TFunction, orderRoute: string, restart: boolean, isLeatherGoods: boolean) => ([
  {
    index: 0,
    title: t('Nos tarifs', { ns: 'Footer' }),
    links: [
      {
        text: t('Prendre rendez-vous'),
        url: orderRoute,
        onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart),
      },
      { text: t('Grille des tarifs'), url: routesMap.PricingsPage.url },
      { text: t('Aide'), url: routesMap.HowItWorksPage.url },
    ],
  },
  {
    index: 1,
    title: t('Nos services'),
    links: [
      { text: t('La Méthode'), url: routesMap.HowItWorksPage.url },
      { text: t('Couture'), url: routesMap.CoutureServicesPage.url },
      { text: t('Maroquinerie'), url: routesMap.LeatherGoodsServicesPage.url },
      { text: t('Cordonnerie'), url: routesMap.ShoesServicesPage.url },
      { text: t('Broderie'), url: routesMap.EmbroideryServicesPage.url },
    ],
  },
  {
    index: 2,
    title: 'Localisations',
    links: getLocalisationBlock(isLeatherGoods),
  },
  {
    index: 3,
    title: t('Nous rejoindre'),
    links: [
      { text: t('Devenir Artisan'), url: routesMap.BeTillistePage.url },
      { text: t('Devenir partenaire'), url: routesMap.WhyBecomePartner.url },
      { text: t('Nos boutiques'), url: routesMap.Retail.url },
      { text: t('Nos événements'), url: routesMap.EventsPage.url },
      { text: t('Instagram'), urlNewTab: 'https://www.instagram.com/tilli.jointhecycle/' },
    ],
  },
  {
    index: 4,
    title: t('À propos', { ns: 'Footer' }),
    links: [
      { text: t('Notre histoire'), url: routesMap.AboutPage.url },
      { text: t('Nos artisans'), url: routesMap.OurArtisansPage.url },
    ],
  },
  {
    index: 5,
    title: 'Notre blog',
    links: [
      { text: 'Bonus Réparation', url: routesMap.RepairBonusPage.url },
    ],
  },
]);

export const getSEAMultilingualFooterContent = (t: TFunction, orderRoute: string, restart: boolean) => ([
  {
    index: 0,
    title: t('Nos tarifs', { ns: 'Footer' }),
    links: [
      {
        text: t('Prendre rendez-vous'),
        url: orderRoute,
        onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart),
      },
      { text: t('Grille des tarifs'), url: routesMap.PricingsPage.url },
      { text: t('Aide'), url: routesMap.HowItWorksPage.url },
    ],
  },
  {
    index: 1,
    title: t('Nos services'),
    links: [
      { text: t('Retouche', { ns: 'Footer' }), url: orderRoute, onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart) },
      { text: t('Réparation', { ns: 'Footer' }), url: orderRoute, onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart) },
      { text: t('Customisation', { ns: 'Footer' }), url: orderRoute, onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart) },
      { text: t('Broderie', { ns: 'Footer' }), url: orderRoute, onClick: () => pushOrderStartToGTM(orderRoute, 'Footer', restart) },
    ],
  },
  {
    index: 4,
    title: t('À propos', { ns: 'Footer' }),
    links: [
      { text: t('Notre histoire'), url: routesMap.AboutPage.url },
      { text: t('Nos artisans'), url: routesMap.OurArtisansPage.url },
    ],
  },
]);
